import React from "react";

// Generic renderer that displays current value on top and legacy (original) value below when changed.
// Expects grid context to provide a changes map (defaults to locIdChanges) keyed by row __id.
// For now, we read from context.locIdChanges to support Locations; can be extended later.
const LegacyValueTrackRenderer = (props) => {
  const value = props.value ?? "";
  const row = props.data || {};
  const status = row.__status;

  // When merging, do not show the special renderer per requirements
  if (status === "merged") {
    return <span>{value}</span>;
  }

  const changes = props.context?.locIdChanges || {};
  const rowId = row.__id || row.id;
  const entry = rowId ? changes[rowId] : undefined;
  const original = entry?.original;

  if (original && original !== value) {
    return (
      <div className="flex flex-col leading-tight">
        <span className="text-slate-900">{value}</span>
        <span className="text-[11px] text-slate-500">Legacy: {original}</span>
      </div>
    );
  }

  return <span>{value}</span>;
};

export default LegacyValueTrackRenderer;
